import { render, staticRenderFns } from "./album-details.vue?vue&type=template&id=c6a6b340"
import script from "./album-details.vue?vue&type=script&lang=js"
export * from "./album-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports